<template>
    <div>
        <div class="page-tit">
            <div class="page-tit-txt">
                <span>实名认证</span>
                <em>（您输入的资料将作为初始数据，将用于负责人变更或离职找回账号，请尽量准确填写）</em>
            </div>
        </div>
        <div class="certifiy-main">
            <AcForm v-if="cur === 'acform'" class="common-certification-border" :certifyInfo="certifyInfo" />
            <ADVPAndR v-if="cur === 'advpa'" class="common-certification-border" :certifyInfo="certifyInfo" />
        </div>
    </div>
</template>


<script>
import AcForm from './AcForm'
import ADVPAndR from './ADVPAndR'
import { mapState, mapActions } from 'vuex'
export default {
    name: 'certifyIndex',
    components: {
        AcForm, ADVPAndR
    },
    data () {
        return {
            curAc: false,
            certifyInfo: {},
            cur: ''
        }
    },
    created () {
        this.getCertifyInfo()
    },
    methods: {
        ...mapActions('certify', ['findCertifyByUserId']),
        async getCertifyInfo () {
            let { data } = await this.findCertifyByUserId()
            if (data.isSuccess) {
                this.certifyInfo = data.data || {}
                if (this.certifyInfo.status === '1') {
                    this.cur = 'advpa'
                } else {
                    this.cur = 'acform'
                }
            } else {
                this.certifyInfo = {}
                this.cur = 'acform'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
header {
    font-weight: normal;
    padding: 32px 0 30px;
    i {
        display: block;
        font-size: 15px;
        color: #666;
        height: 18px;
        line-height: 18px;
        background: url(../../assets/images/laba.jpg) no-repeat 13px center;
        margin-top: 18px;
        padding-left: 45px;
    }
}
.certifiy-main {
    background-color: #fff;
    border-radius: 4px;
}
</style>
